import React, { Component } from 'react'
import { connect } from 'react-redux'
import { deleteTeamMember, showOrganizationEditForm } from '../actions'
import OrganizationForm from './OrganizationForm'
import history from '../history'

class OrganizationEdit extends Component {
  componentWillMount() {
    if(!this.props.user.admin){
      history.push('/organization')
    }
  }
  render() {
    const { teamId, members, users, editTeam, deleteTeamMember, showOrganizationEditForm } = this.props
    return (
      <div>
        {members?
          members.map(uid => {
            return (
              <div key={teamId + uid} className="member">{users[uid].realName} <span className="icon" onClick={() => deleteTeamMember(teamId, members, uid)} ><i className="far fa-trash-alt"></i></span></div>
            )
          })
        :
          null
        }
        {editTeam && editTeam === teamId?
          <OrganizationForm />
        :
          <span className="icon" onClick={() => showOrganizationEditForm(teamId, members)} ><i className="fas fa-user-plus"></i></span>
        }
      </div>
    )
  }
}

export default connect(
  state => ({
    user: state.user,
    editTeam: state.organization.editTeam,
    users: state.users
  }),
  { deleteTeamMember, showOrganizationEditForm }
)(OrganizationEdit)



// WEBPACK FOOTER //
// ./src/components/OrganizationEdit.js